jQuery(function () {
  if (jQuery('.js-productSlider').length) {
    let productSlider = new Swiper('.js-productSlider', {
      loop: true,
      speed: 600,
      slidesPerView: 3,
      spaceBetween: 20,
      direction: 'horizontal',
      effect: 'slide',
      centeredSlides: true,
      autoHeight: true,
      loopAdditionalSlides: 1,
      slideToClickedSlide: true,

      autoplay: {
        delay: 3000,
        stopOnLast: false,
        disableOnInteraction: true
      },

      navigation: {
        prevEl: '.js-productSliderPrev',
        nextEl: '.js-productSliderNext',
      },

      on: {
        // init: function () {
        //   jQuery('.js-productSlider').find('.js-modal').on('click', function (event) {
        //     const targetSliderId = `${jQuery(this).attr('href')}-slider`.slice(1);
        //     const sliderIndex = jQuery(this).parent().data('swiper-slide-index');
        //     let targetSlider;
        //     for (let i = 0; i < modalSliders.length; i++) {
        //       if (jQuery(modalSliders[i].el).attr('id') == targetSliderId) {
        //         targetSlider = modalSliders[i];
        //         break;
        //       }
        //     }
        //     targetSlider.slideTo(sliderIndex, 0);
        //   });
        // },
        slideChange: function () {
          const names = document.querySelectorAll('.js-productNames li');
          const titles = document.querySelectorAll('.js-productTitles li');
          const metas = document.querySelectorAll('.js-productMeta li');
          const realIndex = this.realIndex;
          if (names.length === titles.length && titles.length === metas.length) {
            names.forEach((name, index) => {
              jQuery(name).removeClass('is-active');
              jQuery(titles[index]).removeClass('is-active');
              jQuery(metas[index]).removeClass('is-active');
            });
            jQuery(names[realIndex]).addClass('is-active');
            jQuery(titles[realIndex]).addClass('is-active');
            jQuery(metas[realIndex]).addClass('is-active');
          }
        }
      }
    });
  }
});
